/**
 * @generated SignedSource<<15166df4b514ff5faecb39b440d34d80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFDFQuoteVariant_deliveryOptions$data = ReadonlyArray<{
  readonly isFromDealer: boolean | null;
  readonly isFromInternal: boolean | null;
  readonly serviceMethod: {
    readonly isFreight: boolean | null;
    readonly serviceType: string | null;
  } | null;
  readonly " $fragmentType": "useFDFQuoteVariant_deliveryOptions";
}>;
export type useFDFQuoteVariant_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: useFDFQuoteVariant_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFDFQuoteVariant_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useFDFQuoteVariant_deliveryOptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFreight",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromDealer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFromInternal",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "443fc4d304dc10516142c1b43fc839f6";

export default node;
